import React from 'react';
import { C, font, serif } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const SIDE_NOTES = [
  'Lo que aprendí vendiendo en tianguis',
  'Mi primer error con precios',
  'Por qué regresan mis clientes',
  'Proveedor de piel: acierto',
];

export default function BitacoraPreview({ isMobile, isTablet }) {
  const reveal = useScrollReveal();
  const mob = isMobile;

  return (
    <section
      id="bitacora"
      ref={reveal.ref}
      style={{
        maxWidth: 1180, margin: '0 auto',
        padding: mob ? '2.5rem 1rem' : '4rem 1.5rem',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      <div style={{
        display: 'grid',
        gridTemplateColumns: mob ? '1fr' : '1fr 1fr',
        gap: mob ? 32 : 56, alignItems: 'center',
      }}>
        {/* Left — note UI mockup */}
        <div style={{
          background: 'rgba(255,255,255,0.04)',
          border: `1px solid ${C.border}`,
          borderRadius: 24, padding: 24,
          display: 'grid',
          gridTemplateColumns: mob ? '1fr' : '170px 1fr',
          gap: 20, minHeight: mob ? 'auto' : 380,
        }}>
          {/* Sidebar */}
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 10, letterSpacing: 2, fontWeight: 700, textTransform: 'uppercase', padding: 0 }}>MI BITÁCORA</span>
            {SIDE_NOTES.map((n, i) => (
              <span key={i} style={{
                padding: '6px 8px', borderRadius: 6,
                ...(i === 1 ? { background: 'rgba(255,255,255,0.06)', color: '#fff' } : {}),
              }}>{n}</span>
            ))}
          </div>

          {/* Note content */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {/* Tags */}
            <div style={{ display: 'flex', gap: 8 }}>
              <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 700, background: 'rgba(235,99,107,0.15)', color: C.coral }}>#error</span>
              <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 700, background: 'rgba(93,193,185,0.15)', color: C.turquesa }}>#acierto</span>
              <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 700, background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.55)' }}>Mundo 01</span>
            </div>

            {/* Title */}
            <p style={{ fontFamily: serif, fontSize: mob ? 24 : 30, lineHeight: 1, margin: 0, color: '#fff' }}>
              Mi primer error con precios
            </p>

            {/* Body */}
            <p style={{ margin: 0, fontSize: 14, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7 }}>
              Puse el precio del cinturón por lo que me costaba la piel, no por lo que vale el trabajo.
              Vendí mucho y no gané nada. Lo arreglé en la misión{' '}
              <span style={{ color: C.turquesa, borderBottom: '1px dashed rgba(93,193,185,0.5)' }}>[[Precio definido]]</span>{' '}
              calculando margen por pieza.
            </p>

            {/* Footer */}
            <div style={{ marginTop: 'auto', display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ fontSize: 11, padding: '4px 10px', borderRadius: 999, fontWeight: 700, background: C.turquesa, color: '#06201D' }}>Compartido con la red</span>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>14 emprendedores lo guardaron</span>
            </div>
          </div>
        </div>

        {/* Right — copy */}
        <div>
          <p style={{
            fontSize: mob ? 11 : 12, letterSpacing: 3, fontWeight: 700,
            textTransform: 'uppercase', color: C.coral, margin: '0 0 14px',
          }}>
            03 · Tu bitácora de aprendizajes
          </p>

          <h2 style={{
            fontFamily: serif,
            fontSize: mob ? 28 : isTablet ? 36 : 48,
            fontWeight: 400, lineHeight: 1, margin: '0 0 16px', color: '#fff',
          }}>
            Anota tus aciertos y tus errores.{' '}
            <em style={{ color: C.coral, fontStyle: 'italic' }}>Que le sirvan a alguien.</em>
          </h2>

          <p style={{
            fontSize: mob ? 15 : 17, color: 'rgba(255,255,255,0.55)',
            lineHeight: 1.6, margin: '0 0 16px',
          }}>
            Cada misión deja una nota: qué hiciste, qué salió mal y qué aprendiste.
            Lo privado se queda contigo; lo que compartes ayuda a otro emprendedor a
            no repetir tu error. Es tu gestor de conocimiento, sin complicaciones.
          </p>

          <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)' }}>
            Tus notas se conectan con [[wikilinks]] y forman tu propia red de ideas, si quieres ir más a fondo.
          </span>
        </div>
      </div>
    </section>
  );
}
